// import React from "react";
// import { Link } from "react-router-dom";

// function CategorySection({ title, products  }) {

//    const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);      
//     const hasHalfStar = rating % 1 !== 0;       
//     const emptyStars = 5 - Math.ceil(rating);   

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
//     }
//     if (hasHalfStar) {
//       stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
//     }
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
//     }

//     return stars;
//   };
//   return (
//     <div className="container-fluid px-lg-5 px-2 py-3 backcolor1">
//       {/* <h3 className="mb-3">{title}</h3> */}
//      {/* ===== HEADER ===== */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h3 className="mb-0">{title}</h3>

//         <Link
//           to="/products"
//           state={{ category: title }}
//           className="text-decoration-none text-dark d-flex align-items-center gap-1"
//         >
//           View All <i className="bi bi-chevron-right viewAll"></i>
//         </Link>
//       </div>
//       <div className="row gapp">
//         {products.length > 0 ? (
//           products.slice(0, 4).map((p) => (
//             <div className="col-6 col-sm-4 col-md-3 mb-3" key={p.prod_id}>
//               <div className="card custom-card">
//                  <div className="position-relative">
//                <Link to={`/DetailsSection3/${p.prod_id}`} className="text-decoration-none">
//                 <img
//                   src={`https://ecom.cyberathon.com/${p.Product_image}`}
//                   className="card-img-top"
//                   alt={p.Product_name}
//                 /></Link>
//                  <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
//                     {p.discount}% off
//                   </span>
//                 </div>
//                 <div className="card-body text-start">
//                   <h6 className="fw-bold">{p.Product_name}</h6>

//                   <div className="d-flex gap-2">
//                     <p className="text-success fw-bold mb-0">
//                       ₹{p.current_price}
//                     </p>

//                     {p.old_price && (
//                       <small className="text-muted text-decoration-line-through">
//                         ₹{p.old_price}
//                       </small>
//                     )}
//                   </div>

//                   <div className="text-warning mb-1 d-flex gap-1">
//                     {renderStars(p.rating)}
//                     <small className="text-dark ms-1">({p.rating})</small>
//                   </div>

//                   <Link to={`/DetailsSection3/${p.prod_id}`} className="text-decoration-none">
//                     <div className="bg-col text-white fw-semibold py-2 rounded text-center">
//                       Add to Cart <i className="bi bi-bag ms-2" />
//                     </div>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p>No products found</p>
//         )}
//       </div>
//     </div>
//   );
// }

// export default CategorySection;











import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCart } from "../../../Context/CartContext";
// import { toast } from "react-toastify";
import { useWishlist } from "../../../Context/WishlistContext";

const BASE_URL = "https://ecom.cyberathon.com";

// const hasValidDiscount = (product) => {
//   const discount = Number(product.discount);
//   return !isNaN(discount) && discount > 0;
// };

const hasValidDiscount = (product) => {
  const offDiscount = Number(product.off_discount);   // ★ CHANGED: discount → off_discount
  return !isNaN(offDiscount) && offDiscount > 0;
};

function CategorySection({ title, products,  categoryName }) {
  const { setCartCount } = useCart();
const { wishlistItems, toggleWishlist } = useWishlist();
const formatCardDescription = (html) => {
  if (!html) return "";

  return html
    // HTML tags remove
    .replace(/<[^>]*>/g, " ")
    // number. text → sirf text
    .replace(/\d+\./g, "")
    // multiple spaces clean
    .replace(/\s+/g, " ")
    .trim();
};
  const [addedItems, setAddedItems] = useState([]);
  const [shareProduct, setShareProduct] = useState(null);
const [shareUrl, setShareUrl] = useState("");


  /* 🔹 Check which products are already in cart on load */
  useEffect(() => {
    const checkCart = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = !userId ? localStorage.getItem("cart_token") : null;

      if (!userId && !cartToken) return;

      try {
        const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
          user_id: userId ? userId : null,
          cart_token: cartToken ? cartToken : null,
        });

        if (res.data.status) {
          const prodIds = res.data.cart_items.map(item => item.prod_id);
          setAddedItems(prodIds);
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkCart();
  }, []);

  /* 🔹 Add to Cart function */
  const handleAddToCart = async (prod_id) => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = !userId ? localStorage.getItem("cart_token") || crypto.randomUUID() : null;

    if (cartToken && !localStorage.getItem("cart_token")) {
      localStorage.setItem("cart_token", cartToken);
    }

    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
        user_id: userId ? userId : null,
        cart_token: cartToken,
        prod_id: prod_id,
        qty: 1
      }, { headers: { "Content-Type": "application/json" } });

      if (res.data.status === true) {
        setAddedItems(prev => [...prev, prod_id]);
         // 🔥 IMPORTANT
  setCartCount(prev => prev + 1);
  // toast.success("Product added to cart successfully!");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("API Error while adding to cart");
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(rating);

    for (let i = 0; i < fullStars; i++)
      stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
    if (hasHalfStar)
      stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
    for (let i = 0; i < emptyStars; i++)
      stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);

    return stars;
  };
const handleShare = (product) => {

  const baseUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://shopeindia.co.in";

  const url = `${baseUrl}/DetailsSection3/${product.prod_id}`;

  setShareProduct(product);
  setShareUrl(url);
};

const groupedProducts = Object.values(
  products.reduce((acc, item) => {

    if (!acc[item.prod_id]) {
      acc[item.prod_id] = {
        ...item,
        variants: []
      };
    }

    // variant add karo
    if (item.size) {
      acc[item.prod_id].variants.push({
        size: item.size,
        variant_price: item.variant_price,
        variant_old_price: item.variant_old_price
      });
    }

    return acc;
  }, {})
);

  return (
    <>
    <div className="container-fluid px-lg-5 px-2 py-3 backcolor1">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{title}</h3>
        <Link
          to="/products"
          // state={{ category: title }}

//           state={{ 
//   categoryKey: title.replaceAll(" ", "") 
// }}
 state={{
    categoryKey: categoryName
      ? categoryName
      : title.replaceAll(" ", "")
  }}
          className="text-decoration-none text-dark d-flex align-items-center gap-1"
        >
          View All <i className="bi bi-chevron-right viewAll"></i>
        </Link>
      </div>

      <div className="row gapp">
        {products.length > 0 ? (
          // products.slice(0, 4).map((p) => {
            groupedProducts.slice(0, 4).map((p) => {
              const displayPrice =
  p.variants && p.variants.length > 0
    ? p.variants[0].variant_price
    : p.current_price;

const displayOldPrice =
  p.variants && p.variants.length > 0
    ? p.variants[0].variant_old_price
    : p.old_price;

            const isAdded = addedItems.includes(p.prod_id);
            return (
              <div className="col-6 col-sm-4 col-md-3 mb-3" key={p.prod_id}>
                <div className="card custom-card">
                  <div className="position-relative">
                    <Link to={`/DetailsSection3/${p.prod_id}`} className="text-decoration-none">
                      <img
                        src={`https://ecom.cyberathon.com/${p.Product_image?.[0]}`}
                        className="card-img-top"
                        alt={p.Product_name}
                      />
                    </Link>
                    <i
  className="bi bi-share position-absolute top-0 start-0 m-2 fs-5 px-2 py-1 bg-white rounded-circle"
  style={{ cursor: "pointer", zIndex: 2 }}
  onClick={(e) => {
    e.stopPropagation();
    handleShare(p);
  }}
></i>
                    <i
  className={`position-absolute top-0 end-0 m-2 fs-5 px-2 py-1 shadow rounded-circle ${
    wishlistItems.includes(p.prod_id)
      ? "bi bi-suit-heart-fill text-danger bg-white"
      : "bi bi-suit-heart text-white bg-dark bg-opacity-50"
  }`}
  style={{ cursor: "pointer", zIndex: 2 }}
  onClick={(e) => {
    e.stopPropagation();
    toggleWishlist(p.prod_id);
  }}
></i>

                    {/* <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                      {p.discount}% off
                    </span> */}

                    {/* {hasValidDiscount(p) && (
                      <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                        {p.discount}% off
                      </span>
                    )} */}

                    {hasValidDiscount(p) && (
                      <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                        {p.off_discount}% off   {/* ★ CHANGED: discount → off_discount */}
                      </span>
                    )}
                  </div>

                  <div className="card-body text-start">
                     <Link to={`/DetailsSection3/${p.prod_id}`} className="text-decoration-none text-dark">
                     {p.pdetails_sheading && (
        <small className="d-block card-subheading one-line-ellipsis">
          {p.pdetails_sheading}
        </small>
      )}
                    <h6 className="fw-bold two-line-ellipsis product-title">{p.Product_name}</h6>
                    {/* <small className="d-block one-line-ellipsis">{p.discription}</small> */}
                    <small className="d-block desc-space one-line-ellipsis">
  {/* {p.discription ? p.discription : "\u00A0"} */}
   {p.discription?.trim() ? formatCardDescription(p.discription) : "\u00A0"}
</small>
                    {/* <div className="d-flex gap-2">
                      <p className="text-success fw-bold mb-0">₹{p.current_price}</p>
                      {p.old_price && (
                        <small className="text-muted text-decoration-line-through">₹{p.old_price}</small>
                      )}
                    </div> */}
<div className="price-space">
  {p.current_price ? (
    <>
      {/* <p className="text-success fw-bold mb-0">₹{p.current_price}</p> */}
      <p className="text-dark fw-bold mb-0">₹{displayPrice}</p>
      {/* {p.old_price && (
        <small className="text-muted text-decoration-line-through">
          ₹{p.old_price}
        </small>
      )} */}
      {displayOldPrice && (
  <small className="text-muted text-decoration-line-through">
    ₹{displayOldPrice}
  </small>
)}
    </>
  ) : (
    "\u00A0"
  )}
</div>
                    {/* <div className="text-warning mb-1 d-flex gap-1">
                      {renderStars(p.rating)}
                      <small className="text-dark ms-1">({p.rating})</small>
                    </div> */}
<div className="rating-space">
  {p.rating ? (
    <>
      {renderStars(p.rating)}
      <small className="text-dark ms-1">({p.rating})</small>
    </>
  ) : (
    "\u00A0"
  )}
</div></Link>
                    <div
                      className={`bg-col fw-semibold py-2 rounded text-center text-white`}
                      style={{ cursor: isAdded ? "default" : "pointer" }}
                      onClick={() => !isAdded && handleAddToCart(p.prod_id)}
                    >
                      {isAdded ? (
                        <>Added <span className="ms-2"><i className="bi bi-check2"></i></span></>
                      ) : (
                        <>Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
    {shareProduct && (
  <div className="share-overlay">
    <div className="share-popup">

      <div className="d-flex justify-content-between mb-3">
        <h5>Share Product</h5>
        <i
          className="bi bi-x-lg"
          style={{ cursor: "pointer" }}
          onClick={() => setShareProduct(null)}
        ></i>
      </div>

      <input
        type="text"
        value={shareUrl}
        readOnly
        className="form-control mb-3"
      />

      <div className="d-flex justify-content-around">

        <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
            shareProduct.Product_name + " " + shareUrl
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="bi bi-whatsapp text-success fs-3"></i>
        </a>

        <button
          onClick={() => {
            navigator.clipboard.writeText(shareUrl);
            alert("Link copied!");
          }}
        >
          <i className="bi bi-link-45deg fs-3"></i>
        </button>

      </div>

    </div>
  </div>
)}
</>
  );
}

export default CategorySection;